import React from "react"
import PropTypes from "prop-types"

import NumberForm from "./number-form"

class CustomButton extends React.Component {

  state = {isFormActive: false, numberInForm: ""}

  onClick = () => this.setState({isFormActive: true})

  changeForm = e => this.setState({numberInForm: e.target.value})

  cancelForm = () => this.setState({isFormActive: false})

  confirmForm = () => {
    this.cancelForm()
    const {numberInForm} = this.state
    this.props.onChange(numberInForm ? parseFloat(numberInForm) : null)
  }

  render () {
    if (this.state.isFormActive) {
      return <NumberForm onChange={this.changeForm} onConfirm={this.confirmForm} onCancel={this.cancelForm} />
    } else {
      return <button className="shop-reservation__price-button custom" onClick={this.onClick}>Custom</button>
    }
  }
}

CustomButton.propTypes = {
  onChange: PropTypes.func.isRequired,
}

export default CustomButton
